import styled from 'styled-components';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Tooltip from '../Tooltip/Tooltip.jsx';

export default function CardTabs({ tabs, activeTab, setActiveTab }) {
  const checkVariant = (name, disabled) => {
    if (disabled) return 'disabled';
    if (name === activeTab) return 'active';

    return 'inactive';
  };

  const handleClick = (name, disabled) => {
    if (disabled) return;

    setActiveTab(name);
  };

  return tabs.map(({ name, content, disabled, tooltip }) => (
    <Tab
      key={name}
      onClick={() => handleClick(name, disabled)}
      variant={checkVariant(name, disabled)}
      data-tip={disabled ? tooltip : null}
    >
      <Tooltip />
      {content}
    </Tab>
  ));
}

const Tab = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 48px;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
  border: 1px solid ${themeGet('colors.black.10')};
  padding: 16px 24px;
  border-bottom: 0;

  ${variant({
    variants: {
      active: {
        color: 'primary.100',
        backgroundColor: 'white',
        ':after': {
          background: 'white',
          position: 'absolute',
          width: '100%',
          height: '1px',
          bottom: '-1px',
          left: '0',
        },
      },
      inactive: {
        color: 'black.80',
        backgroundColor: 'black.5',
      },
      disabled: {
        color: 'black.60',
        backgroundColor: 'black.5',
        cursor: 'default',
      },
    },
  })}
  &:after {
    content: '';
  }
  &:not(:last-child) {
    margin-right: 8px;
  }
`;
